import React, { useMemo } from 'react';
import styles from './index.module.scss';
import isEmpty from 'lodash/isEmpty';
import ListData from '../../Details/ListData';
import { ReactComponent as Avail } from 'images/icon_user_available.svg';
import { ReactComponent as Unavail } from 'images/icon_user_unavailable.svg';
import { ReactComponent as OnTask } from 'images/icon_user_interruptabletask.svg';
import { ReactComponent as CriticalTask } from 'images/icon_user_ontask.svg';
import { ReactComponent as LoggedOut } from 'images/icon_user_notloggedin.svg';
import { ReactComponent as OnBreak } from 'images/icon_user_onbreak.svg';
import { translateValue } from 'utils/methods/helpers';
import Proptypes from 'prop-types';

const STATUS_WIDTH = 40;
const widgetColumns = [
  { headerName: 'Role', field: 'id', width: 90 },
  {
    headerName: 'AV',
    field: 'available',
    width: STATUS_WIDTH,
    cellRenderer: 'centredNumber',
    // eslint-disable-next-line react/display-name
    headerComponentFramework: () => {
      // this is the key we need
      return (
        <div className={styles.header}>
          <Avail className={styles.img} />
        </div>
      );
    },
  },
  {
    headerName: 'OT',
    field: 'task',
    width: STATUS_WIDTH,
    cellRenderer: 'centredNumber',
    // eslint-disable-next-line react/display-name
    headerComponentFramework: () => {
      // this is the key we need
      return (
        <div className={styles.header}>
          <OnTask className={styles.img} />
        </div>
      );
    },
  },
  {
    headerName: 'CT',
    field: 'criticalTask',
    width: STATUS_WIDTH,
    cellRenderer: 'centredNumber',
    // eslint-disable-next-line react/display-name
    headerComponentFramework: () => {
      // this is the key we need
      return (
        <div className={styles.header}>
          <CriticalTask className={styles.img} />
        </div>
      );
    },
  },
  {
    headerName: 'BR',
    field: 'break',
    width: STATUS_WIDTH,
    cellRenderer: 'centredNumber',
    // eslint-disable-next-line react/display-name
    headerComponentFramework: () => {
      // this is the key we need
      return (
        <div className={styles.header}>
          <OnBreak className={styles.img} />
        </div>
      );
    },
  },
  /**
   * TODO hide if No attendance tracking
   */
  {
    headerName: 'UN',
    field: 'unavailable',
    width: STATUS_WIDTH,
    cellRenderer: 'centredNumber',
    // eslint-disable-next-line react/display-name
    headerComponentFramework: () => {
      // this is the key we need
      return (
        <div className={styles.header}>
          <Unavail className={styles.img} />
        </div>
      );
    },
  },
  /**
   * TODO hide if No attendance tracking
   */ {
    headerName: 'LO',
    field: 'loggedOut',
    width: STATUS_WIDTH,
    cellRenderer: 'centredNumber',
    // eslint-disable-next-line react/display-name
    headerComponentFramework: () => {
      // this is the key we need
      return (
        <div className={styles.header}>
          <LoggedOut className={styles.img} />
        </div>
      );
    },
  },
];
// eslint-disable-next-line react/display-name
const PersonnelWidget = React.memo(({ data, title }) => {
  const memoisedColumns = useMemo(
    () => widgetColumns,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
  return (
    <div className={styles.widget}>
      <div className={styles.left}>
        <span className={styles.title}>{translateValue(title)}</span>
      </div>
      {!isEmpty(data) && (
        <ListData
          col={memoisedColumns}
          data={data}
          showPaginate={false}
          className={styles.listData}
        />
      )}
      <div className={styles.left}></div>
    </div>
  );
});
PersonnelWidget.propTypes = {
  data: Proptypes.array,
  title: Proptypes.string,
};
export default PersonnelWidget;
